
<div :class="['audit-log-item', { clickable }]" @click.stop.prevent="handleClick">
  <align flex>
    <div>
      <div class="log-time">
        {{ $filters.datetime(log.date) }}
      </div>
      <div v-if="employeeLabel" class="log-time">
        {{ employeeLabel }}
      </div>
      <div v-if="log.label" class="log-label">
        <b>{{ log.label }}</b>
      </div>
      <div>{{ description }}</div>
    </div>

    <div>
      <icon-button
        v-if="hasChanges"
        :icon="expanded ? 'expand_less' : 'expand_more'"
        @click.stop.prevent="expanded = !expanded"
      />
    </div>
  </align>

  <section v-show="expanded" class="changes">
    <div v-for="(change, i) in changes" :key="i">
      <div><b>{{ change.label }}</b></div>
      <div class="change-before">
        <span>{{ change.beforeValue }}</span>
      </div>
      <div><span>{{ change.afterValue }}</span></div>
    </div>
  </section>
</div>
